const COMPANY_NAME = {
    HTZ: "HitechZone",
    RN: "RailNinja",
    LS: "LetStay",
}

module.exports = {
    COMPANY_NAME,
}